import { type IWhenDateFieldPeriod } from 'entities/Campaign'

export const whenDateFieldsPeriodConfig: Record<IWhenDateFieldPeriod, string> = {
  before: 'Before',
  on: 'On',
  after: 'After',
}
